import React, { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Nav } from 'react-bootstrap';
import { faEnvelope, faMapMarkerAlt, faPhoneAlt } from '@fortawesome/free-solid-svg-icons';

export default ({withNames, itemProps, ...props}) => {
	return <Nav {...props}>
		<Nav.Item as="li" {...itemProps}>
            <Nav.Link as="span" className="">
                <a className="pr-1" href="tel:4701392" >
                    <FontAwesomeIcon icon={faPhoneAlt} /> 470-1392
                </a>
                /
                <a className="pl-1" href="tel:2650312">
                    265-0312
                </a>
            </Nav.Link>
        </Nav.Item>
        <Nav.Item as="li" {...itemProps}>
            <Nav.Link href="mailto:ventas@iqsac.com.pe" target="_blank">
                <FontAwesomeIcon icon={faEnvelope} /> ventas@iqsac.com.pe
            </Nav.Link>
        </Nav.Item>
        <Nav.Item as="li" {...itemProps}>
            <Nav.Link href="https://goo.gl/maps/4dVdemgigNEgkQUv6" target="_blank">
                <FontAwesomeIcon icon={faMapMarkerAlt} /> Paseo de la República 1728 - Lince - Lima - Perú
            </Nav.Link>
        </Nav.Item>
		{/* <Nav.Item as="li">
			<Nav.Link eventKey="link-1">Link</Nav.Link>
		</Nav.Item>
		<Nav.Item as="li">
			<Nav.Link eventKey="link-2">Link</Nav.Link>
		</Nav.Item> */}
	</Nav>
}
